/* Uit Krabbelpaal.dc.html; bodies letterlijk overgenomen. */

import { api, asJson, serverMsg } from '../lib/api.js';
import { AV, AV_EMPTY, BIO_MAX, ONLINE_MS, PB_URL, PIN_FAIL_MSG } from '../lib/config.js';
import { avatarUrl } from '../lib/pixels.js';
import { playBlip, playHello } from '../lib/sound.js';
import * as store from '../lib/store.js';

export default {
  openSeenLog() { return this.setState({ dialog: 'seenlog', notifOpen: false }, this.fetchAccounts); },

  closeSeenLog() { return this.setState({ dialog: null }); },

  // Wie net online komt, wordt met een kort vrolijk deuntje aangekondigd.
  announceOnline(accounts) {
      const now = Date.now();
      const me = this.state.accountId;
      const ids = {};
      const fresh = [];
      (accounts || []).forEach((a) => {
        const t = Date.parse(a.lastSeen || '');
        if (isNaN(t) || now - t >= ONLINE_MS) return;
        ids[a.id] = true;
        if (a.id !== me && this.onlineIds && !this.onlineIds[a.id]) fresh.push(a);
      });
      const first = !this.onlineIds;
      this.onlineIds = ids;
      if (first || !fresh.length) return;
      playHello();
      this.notify(
        fresh.length === 1
          ? (fresh[0].name || 'Iemand') + ' is online'
          : fresh.length + ' krabbelaars kwamen online',
        avatarUrl(fresh[0].avatar)
      );
    },

  // The server record is the truth: a stale localStorage copy (older avatar or name)
  // gets overwritten whenever we hear from the server.
  syncMyAccount(accounts) {
      const id = this.state.accountId;
      if (!id) return;
      const mine = (accounts || this.state.accounts).find((a) => a.id === id);
      if (!mine) return;
      const patch = {};
      const srvAvatar = mine.avatar && mine.avatar.length === AV * AV ? mine.avatar : '';
      if (srvAvatar && srvAvatar !== this.state.avatar) {
        patch.avatar = srvAvatar;
        store.set('gp_avatar', srvAvatar);
      }
      if (mine.name && mine.name !== this.state.author) {
        patch.author = mine.name;
        store.set('gp_author', mine.name);
      }
      if (!Object.keys(patch).length) return;
      // Don't yank the ground out from under an editor the user has already touched.
      if (this.state.dialog !== 'account' || !this.state.profileDirty) {
        if (patch.avatar) patch.editAvatar = patch.avatar;
        if (patch.author) patch.editName = patch.author;
      }
      this.setState(patch);
    },

  async saveAccount() {
      const name = (this.state.editName || '').trim();
      if (!name) { this.setState({ accountError: 'Vul een naam in.' }); return; }
      const avatar = this.state.editAvatar || AV_EMPTY;
      if (!/[0-9a-f]/.test(avatar)) { this.setState({ accountError: 'Teken ook een klein profielfotootje.' }); return; }
      const pin = (this.state.editPin || '').trim();
      const mine = this.state.accounts.find((a) => a.id === this.state.accountId);
      const hadPin = !!(mine && mine.pinHash);
      if (pin && pin.length !== 4) { this.setState({ accountError: 'Een pincode is precies vier cijfers.' }); return; }
      if (this.state.accountId && !hadPin && !pin) { this.setState({ accountError: 'Kies een pincode van vier cijfers om je account te beveiligen.' }); return; }
      this.setState({ savingAccount: true, accountError: '' });
      const bio = (this.state.editBio || '').trim().slice(0, BIO_MAX);
      const favFood = (this.state.editFavFood || '').trim().slice(0, BIO_MAX);
      const send = (withBio) => {
        const data = withBio ? { name, avatar, bio, favFood } : { name, avatar };
        const create = () => api(`${PB_URL}/api/collections/paal_accounts/records`, asJson('POST', data));
        if (!this.state.accountId) return create();
        return api(`${PB_URL}/api/collections/paal_accounts/records/${this.state.accountId}`, asJson('PATCH', data))
          .then((r) => (r.status === 404 ? create() : r));
      };
      try {
        let res = await send(!this.state.bioUnsupported);
        // Oudere servers hebben nog geen bio-veld: dan zonder bio opnieuw proberen.
        if (res.status === 400 && !this.state.bioUnsupported) {
          this.setState({ bioUnsupported: true });
          res = await send(false);
        }
        if (!res.ok) {
          throw new Error(await serverMsg(res));
        }
        let rec = await res.json();
        if (pin) {
          const hash = await this.hashPin(pin, rec.id);
          const pres = await api(`${PB_URL}/api/collections/paal_accounts/records/${rec.id}`, asJson('PATCH', { pinHash: hash }));
          if (!pres.ok) throw new Error(PIN_FAIL_MSG);
          rec = await pres.json();
          if (rec.pinHash !== hash) { this.setState({ savingAccount: false, accountError: PIN_FAIL_MSG }); return; }
        }
        store.set('gp_account_id', rec.id);
        store.set('gp_last_id', rec.id);
        store.set('gp_author', name);
        store.set('gp_avatar', avatar);
        try { store.remove('gp_avatar_draft'); } catch (e) {}
        const oldName = mine ? mine.name : '';
        // Vers account: meteen door naar het pincodescherm. Daarna zit het slotje
        // in je accountcentrum.
        const fresh = !this.state.accountId;
        // Een nieuw account is een wissel van wie je bent; zie tamVergeet.
        if (rec.id !== this.state.accountId) this.tamVergeet();
        this.setState({
          accountId: rec.id, lastId: rec.id, author: name, avatar, editPin: '', savingAccount: false, dialog: null,
          pinFor: fresh ? { id: rec.id, name } : this.state.pinFor,
          pinMode: fresh ? 'set' : this.state.pinMode, pinError: ''
        }, () => {
          this.beat(); this.fetchAccounts();
          if (fresh) this.resetPinBoxes();
          if (mine && oldName && oldName !== name) this.renameMyDrawings(rec.id, name);
        });
      } catch (err) {
        this.setState({ savingAccount: false, accountError: 'Opslaan mislukt: ' + err.message });
      }
    },

  async renameMyDrawings(accountId, newName) {
      try {
        const filter = encodeURIComponent(`accountId="${accountId}"`);
        const res = await api(`${PB_URL}/api/collections/${this.collectionName}/records?filter=${filter}&perPage=200&fields=id`);
        if (res.ok) {
          const data = await res.json();
          const items = (data && data.items) || [];
          await Promise.all(items.map((it) => api(`${PB_URL}/api/collections/${this.collectionName}/records/${it.id}`, asJson('PATCH', { author: newName }))));
          if (items.length) this.refreshGallery();
        }
        const mres = await api(`${PB_URL}/api/collections/paal_messages/records?filter=${filter}&perPage=200&fields=id`);
        if (mres.ok) {
          const mdata = await mres.json();
          const mitems = (mdata && mdata.items) || [];
          await Promise.all(mitems.map((it) => api(`${PB_URL}/api/collections/paal_messages/records/${it.id}`, asJson('PATCH', { author: newName }))));
          if (mitems.length) this.fetchChat();
        }
      } catch (e) {}
    },

  async hashPin(pin, id) {
      const data = new TextEncoder().encode('krabbelpaal:' + (id || '').trim() + ':' + pin);
      const buf = await crypto.subtle.digest('SHA-256', data);
      return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, '0')).join('');
    },

  focusPin(i) { const el = this.pinRefs[i] && this.pinRefs[i].current; if (el) { el.focus(); el.select && el.select(); } },

  pinValue() { return (this.state.pinDigits || []).join(''); },

  pinDigitInput(i, e) {
      const ch = (e.target.value || '').replace(/\D/g, '').slice(-1);
      const digits = (this.state.pinDigits || ['', '', '', '']).slice();
      digits[i] = ch;
      this.setState({ pinDigits: digits, pinError: '' }, () => {
        if (ch && i < 3) this.focusPin(i + 1);
        else if (ch && i === 3 && digits.join('').length === 4) this.submitPin();
      });
    },

  pinDigitKey(i, e) {
      if (e.key === 'Enter') { this.submitPin(); return; }
      if (e.key === 'Backspace' && !(this.state.pinDigits || [])[i] && i > 0) {
        e.preventDefault();
        const digits = (this.state.pinDigits || []).slice();
        digits[i - 1] = '';
        this.setState({ pinDigits: digits, pinError: '' }, () => this.focusPin(i - 1));
      }
    },

  closePin() { return this.setState({ pinFor: null, pinDigits: ['', '', '', ''], pinError: '' }); },

  resetPinBoxes() { this.setState({ pinDigits: ['', '', '', ''] }, () => setTimeout(() => this.focusPin(0), 40)); },

  askPin(acc) { return this.setState({ pinFor: acc, pinMode: 'claim', pinError: '' }, this.resetPinBoxes); },

  openPinSetter() { return this.setState({
      pinFor: { id: this.state.accountId, name: (this.state.editName || this.state.author || '').trim() },
      pinMode: this.state.accountId ? 'set' : 'choose', pinError: ''
    }, this.resetPinBoxes); },

  async submitPin() {
      const acc = this.state.pinFor;
      if (!acc) return;
      const left = Math.ceil((this.state.pinLockUntil - Date.now()) / 1000);
      if (left > 0) { this.setState({ pinError: 'Te veel pogingen. Wacht nog ' + left + ' seconden.' }); return; }
      const pin = this.pinValue();
      if (pin.length !== 4) { this.setState({ pinError: 'Vul vier cijfers in.' }); return; }
      if (this.state.pinBusy) return;
  
      if (this.state.pinMode === 'choose') {
        if (!acc.name) { this.setState({ pinError: 'Vul eerst je naam in.' }); return; }
        playBlip();
        this.setState({ editPin: pin, pinFor: null, pinDigits: ['', '', '', ''] });
        return;
      }
  
      this.setState({ pinBusy: true });
  
      if (this.state.pinMode === 'set') {
        try {
          const hash = await this.hashPin(pin, acc.id);
          const res = await api(`${PB_URL}/api/collections/paal_accounts/records/${acc.id}`, asJson('PATCH', { pinHash: hash }));
          if (!res.ok) throw new Error('server ' + res.status);
          const rec = await res.json();
          if (rec.pinHash !== hash) throw new Error('veld ontbreekt');
          playBlip();
          this.setState({ pinBusy: false, pinFor: null, pinDigits: ['', '', '', ''], editPin: '' }, this.fetchAccounts);
        } catch (err) {
          this.setState({ pinBusy: false, pinError: PIN_FAIL_MSG }, this.resetPinBoxes);
        }
        return;
      }
  
      const hash = await this.hashPin(pin, acc.id);
      if (hash === acc.pinHash) {
        playBlip();
        this.setState({ pinBusy: false, pinFor: null, pinDigits: ['', '', '', ''], pinTries: 0 }, () => this.doClaim(acc));
      } else {
        const tries = (this.state.pinTries || 0) + 1;
        const lock = tries >= 5 ? Date.now() + 30000 : 0;
        this.setState({
          pinBusy: false, pinTries: lock ? 0 : tries, pinLockUntil: lock || this.state.pinLockUntil,
          pinError: lock ? 'Te veel pogingen. Wacht 30 seconden.' : 'Die pincode klopt niet.'
        }, this.resetPinBoxes);
      }
    },

  confirmLogout() { return this.setState({ logoutConfirm: true }); },

  cancelLogout() { return this.setState({ logoutConfirm: false }); },

  logout() {
      this.setState({ logoutConfirm: false });
      // Uitloggen wist wie je nu bent, niet wie je was: zo kun je met één klik terug.
      if (this.state.accountId) store.set('gp_last_id', this.state.accountId);
      store.remove('gp_account_id');
      store.remove('gp_author');
      store.remove('gp_avatar');
      this.setState({ accountId: '', lastId: this.state.accountId || this.state.lastId, author: '', avatar: '', editName: '', editAvatar: AV_EMPTY, editPin: '', dialog: null });
      // Het beestje van wie er net was hoort niet te blijven hangen; zie tamVergeet.
      this.tamVergeet();
    },

  // Wie was hier het laatst ingelogd? Blijft bewaard na uitloggen.
  knownLastAccount() {
      const id = (this.state.lastId || '').trim();
      if (!id || id === this.state.accountId) return null;
      return (this.state.accounts || []).find((a) => a.id === id) || { id, name: '', avatar: '' };
    },

  claimAccount(acc) {
      if (acc.pinHash) { this.askPin(acc); return; }
      this.doClaim(acc);
      this.setState({ pinFor: acc, pinMode: 'set', pinError: '' }, this.resetPinBoxes);
    },

  doClaim(acc) {
      // Eerst vergeten, dan wisselen: anders kan een aai van de vorige nog naar de
      // regel van de vorige gaan met jouw naam erop. Zie tamVergeet.
      if (acc.id !== this.state.accountId) this.tamVergeet();
      store.set('gp_account_id', acc.id);
      store.set('gp_last_id', acc.id);
      store.set('gp_author', acc.name);
      store.set('gp_avatar', acc.avatar || AV_EMPTY);
      this.setState({
        accountId: acc.id, lastId: acc.id, author: acc.name, avatar: acc.avatar || AV_EMPTY,
        editName: acc.name, editAvatar: acc.avatar && acc.avatar.length === AV * AV ? acc.avatar : AV_EMPTY,
        // De reden waarmee de poort openging is nu vervuld. Bleef die staan, dan las
        // je boven de lijst nog "Log in of maak een account aan om mee te doen"
        // terwijl je net binnen was, en dook diezelfde regel later op boven het
        // profiel van een collega.
        accountHint: ''
      });
    }
};
